module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2018_13.4d70d297.jpg";